import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { ArrowLeft } from "lucide-react";

export default function MemberDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [m, setM] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/members/${id}`).then((r) => setM(r.data)).catch(() => setM(null)).finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="pt-40 text-center" style={{ color: "var(--ink-muted)" }}>Loading…</div>;
  if (!m) return <div className="pt-40 text-center" style={{ color: "var(--ink-muted)" }}>Member not found.</div>;

  return (
    <div data-testid="member-detail" className="pt-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-8">
        <button onClick={() => navigate(-1)} className="text-xs uppercase tracking-[0.22em] mb-8 flex items-center gap-2 hover:text-[var(--brass)] transition-colors" style={{ color: "var(--ink-muted)" }}>
          <ArrowLeft size={14} /> Directory
        </button>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <div className="aspect-[4/5] overflow-hidden" style={{ background: "var(--surface)" }}>
              <img src={m.portrait} alt={m.name} className="w-full h-full object-cover" />
            </div>
          </div>
          <div className="lg:col-span-7 lg:pl-8">
            <p className="eyebrow mb-4">{m.tier} · {m.industry}</p>
            <h1 className="font-display text-6xl md:text-7xl mb-4 leading-[0.95]">{m.name}</h1>
            <p className="text-xl mb-8 italic" style={{ color: "var(--ink-muted)", fontFamily: "Cormorant Garamond" }}>
              {m.title}, {m.company} · {m.location}
            </p>
            <hr className="hairline my-8" />
            <p className="text-lg leading-[1.85]" style={{ color: "var(--ink)" }}>
              {m.bio}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
